import { useMutation } from '@tanstack/react-query';

import {
  useActiveWorkflowOrFail,
  useRootDocumentOrFail,
} from '../../../../hooks';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { postDocumentTransition } from '../../requests/postDocumentTransition';

export const usePerformDocumentTransition = () => {
  const rootDocument = useRootDocumentOrFail();
  const { workflow } = useActiveWorkflowOrFail();
  const { constructPost } = useRequestConstructor();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: ({ transition }: { transition: string }) =>
      postDocumentTransition(
        constructPost,
        rootDocument.id,
        { definition: rootDocument.definition, workflow },
        transition,
      ),
  });

  const performDocumentTransition = (transition: string): Promise<string> =>
    mutateAsync({ transition }).then((response) => {
      if (!response?.data)
        throw new Error(`Failed to make ${transition} transition for document`);
      return response.data.currentPlace;
    });

  return { performDocumentTransition, isLoading };
};
